import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl, Button, Spinner } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { useEffect, useState } from '@wordpress/element'
import apiFetch from '@wordpress/api-fetch';

/**
 * Adding AuthorizeNet Content
 */
addFilter( 'wp_travel_payment_gateway_fields_authorizenet', 'wp-travel', (content) => {
    return [ ...content, <AuthorizeNetContent /> ]
});

const AuthorizeNetContent = () => {

    const [ isValidating, setIsValidating ] = useState(false); // Declaring local state to check if validation process is ongoing.

    const [ IsDisable, setIsDisable] = useState(false); // Declaring local state to make sure when the validate button should be disable.

    const [ apiData, setApiData ] = useState([]); // Declaring local state to store data that has been fetched from ajax request.

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    /**
     * Destructuring data.
     */
    const {
        currency,
        payment_option_authorizenet,
        wp_travel_authorizenet_api_login_id,
        wp_travel_authorizenet_transaction_key,
        wp_travel_authorizenet_valid_currency,
        wt_test_mode
    } = allData

    const clientIdDesc = __('Get api credentialas <a href="https://www.authorize.net/sign-up/" target="__blank">here</a>', 'wp-travel-pro');

    /**
     * Ajax request for currency verification.
     */
    const validateAccountCurrency = () => {
        setIsValidating(true) // Validation process ongoing so making it true.
        setIsDisable(true) // Making validate btn disable.
        apiFetch({
            url:`${ajaxurl}?action=wp_travel_currency_verification`,
            method:'post'
        }).then( res => {
            setApiData(res) // Storing data in local state.
            setIsValidating(false)
            if ( res.success == true ) {
                if ( !res.data.currencies.includes( currency ) ) { // Checking if fetched currency includes our base currency. for e.g if our base currency is USD then this will check if USD is in fetched data.
                    updateSettings({
                        ...allData,
                        wp_travel_authorizenet_valid_currency: 'no'
                    })
                    return
                }
                updateSettings({ // If our base currency is in fetched data then validation successful.
                    ...allData,
                    wp_travel_authorizenet_valid_currency: 'yes'
                })
            } else { // If no input key is given or wrong key is given then error.
                updateSettings({
                    ...allData,
                    wp_travel_authorizenet_valid_currency: 'no'
                })
            }
        });
    }

    /**
     * After saving api data on local state then notice will be return as per validation successful or error.
     */
    const ValidationResponse = () => {
        if ( apiData && apiData.success == true ) {
            if ( !apiData.data.currencies.includes( currency ) ) {
                return <p className="description notice-error notice">{ __( 'The Merchant account doesn\'t accepts the current store currency. The merchant account accepts following currency: ' + apiData.data.currencies.toString() , 'wp-travel-pro' ) }</p>
            } else {
                return <p className="description notice-success notice">{ __( 'Currency Validated Successfully.', 'wp-travel-pro' ) }</p>
            }
        } else if( apiData && apiData.success == false ) {
            return <p className="description notice-error notice">{ __( 'Failed to Validate Account.', 'wp-travel-pro' ) }</p>
        }
    }

    return (
        <>
            {/**Notice, whether test mode is on or off */ }
            {
                wt_test_mode == 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Test Mode Active', 'wp-travel-pro' ) }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Live Mode Active', 'wp-travel-pro' ) }</p></strong>
            }

            <PanelRow>
                <label>{ _wp_travel.setting_strings.payment.enable_authorize_net }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ payment_option_authorizenet == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                payment_option_authorizenet: 'yes' == payment_option_authorizenet ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{ _wp_travel.setting_strings.payment.enable_authorize_net_note }</p>
                </div>
            </PanelRow>

            {
                payment_option_authorizenet === 'yes' &&
                <>
                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.authorize_net_login_id }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof wp_travel_authorizenet_api_login_id ? wp_travel_authorizenet_api_login_id : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                wp_travel_authorizenet_api_login_id: value
                                            })
                                            setIsDisable(false)
                                        }
                                    }
                                />
                                <p className="description" dangerouslySetInnerHTML={{ __html: clientIdDesc }}></p>
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.authorize_net_transaction_key }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof wp_travel_authorizenet_transaction_key ? wp_travel_authorizenet_transaction_key : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                wp_travel_authorizenet_transaction_key: value
                                            })
                                            setIsDisable(false)
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label></label>
                        <div className="wp-travel-field-value">
                            { 
                                apiData == '' && wp_travel_authorizenet_valid_currency == 'no' &&
                                <p className="description notice-error notice" dangerouslySetInnerHTML={{ __html: 'The store currency and Merchant account currency should be the same.<br>Please validate first to enable the payment gateway.' }}></p>
                            }
                            { wp_travel_authorizenet_valid_currency == 'yes' && <p className="howto" style={{color: 'green'}}>{ __( 'Account and Currency are Valid ', 'wp-travel-pro' ) }<span className="dashicons dashicons-yes-alt"></span></p> }
                            { ValidationResponse() }
                            <Button 
                                onClick = {validateAccountCurrency}
                                isSecondary
                                disabled={IsDisable}
                                style={{marginTop: '10px', marginLeft: '50px'}}
                            >
                                { _wp_travel.setting_strings.payment.authorize_net_transaction_key_validate_acc_and_currency }
                            </Button>
                            { isValidating && <Spinner /> }
                            <p className="description" >{ _wp_travel.setting_strings.payment.authorize_net_transaction_key_validate_acc_and_currency_note }</p>
                        </div>
                    </PanelRow>

                    <PanelRow>
                        <strong><p className="description">{ _wp_travel.setting_strings.payment.authorize_net_note }</p></strong>
                    </PanelRow>
                </>
            }
        </>
    )
}